import localforage from 'localforage';
localforage.config({
  name: 'tajawal'
});
export default localforage;